<template>
  <div class="comment-photo-class uk-grid uk-grid-collapse">
    <!--левая часть-->
    <div class="uk-width-auto">
      <div class="canvas-wrapper">
        <canvas id="backgroundCanvas" :width="imageWidth" :height="imageHeight"></canvas>
        <canvas id="myCanvas" :class="changeCursor()" :width="imageWidth" :height="imageHeight" @mousemove="action" @mousedown="beginAction" @mouseup="stopAction"/>
      </div>
      <div class="canvas-buttons uk-grid uk-grid-collapse uk-child-width-1-5 uk-flex-middle uk-padding-small">
        <!--1-->
        <div>
          <button class="reset-button uk-button uk-button-small-padding uk-width-1-1" @click="resetCanvas">
            <md-icon class="uk-margin-small-right">auto_fix_high</md-icon>Reset
          </button>
        </div>
        <!--2-->
        <div>
          <button v-if="cursor !== 'eraser'" class="undo-redo-buttons uk-button uk-button-small-padding uk-width-1-1" @click="eraser">
            <img class="tm-img-icon tm-img-part" src="/img/icons/eraser_icon_125292.svg" width="30" height="30" alt="">
          </button>
          <button v-else class="undo-redo-buttons eraser uk-button uk-button-small-padding uk-width-1-1">
            <img class="tm-img-icon tm-img-part" src="/img/icons/eraser_icon_125292.svg" width="30" height="30" alt="">
          </button>
        </div>
        <!--3-->
        <div>
          <button class="undo-redo-buttons uk-button uk-button-small-padding uk-width-1-1" @click="undo">
            <md-icon class="">undo</md-icon>
          </button>
        </div>
        <!--4-->
        <div>
          <button class="undo-redo-buttons uk-button uk-button-small-padding uk-width-1-1" @click="redo">
            <md-icon class="">redo</md-icon>
          </button>
        </div>
        <!--5-->
        <div>
          <button v-if="history.length > 0" class = "save-button uk-button uk-button-small-padding uk-width-1-1" @click="saveImage">{{local_page_keys.button_save}}</button>
          <button v-else class = "save-button-disebled uk-button uk-button-small-padding uk-width-1-1" @click="emptyMessage">{{local_page_keys.button_save}}</button>
        </div>
      </div>
    </div>
    <!--правая часть-->
    <div class="uk-width-expand">
      <div class="uk-padding">

        <div class="orange" v-if="!orangeVisible || (!blueVisible && !redVisible && !greenVisible && !blackVisible && !orangeVisible)">
          <button class="uk-button uk-button-border uk-button-small-padding" @click="orangeVisible = true"><span class="material-icons">+</span></button>
        </div>
        <div v-if="orangeVisible" class="orange uk-grid uk-grid-small uk-flex-middle uk-margin">
          <div class="uk-width-auto">
            <button class="uk-button uk-button-border uk-button-small-padding" @click="choosecolor('orange')" :class="activeClass('orange')">
              <md-icon style="color: orange;">mode_edit</md-icon>
            </button>
          </div>
          <div class="uk-width-expand">
            <textarea v-if="colors.includes('orange')" @input="getText('orange')" ref="orangeText" class="uk-textarea orangeText" id="orangeText" :value="orangeText"></textarea>
            <textarea v-else ref="orangeText" class="uk-textarea disabled-input" id="orangeText" :value="orangeText" disabled></textarea>
          </div>
          <div class="uk-width-auto">
            <button @click="deleteColor('orange')"><span class="material-icons">close</span></button>
          </div>
        </div>

        <div class="red" v-if="!redVisible || (!redVisible && !blueVisible && !blackVisible && !greenVisible)">
          <button class="uk-button uk-button-border uk-button-small-padding" @click="redVisible = true"><span class="material-icons">+</span></button>
        </div>
        <div v-if="redVisible" class="red uk-grid uk-grid-small uk-flex-middle uk-margin">
          <div class="uk-width-auto">
            <button class="uk-button uk-button-border uk-button-small-padding" @click="choosecolor('red')" :class="activeClass('red')">
              <md-icon style="color: red;">mode_edit</md-icon>
            </button>
          </div>
          <div class="uk-width-expand">
            <textarea v-if="colors.includes('red')" @input="getText('red')" ref="redText" class="uk-textarea redText" id="redText" :value="redText"></textarea>
            <textarea v-else ref="redText" class="uk-textarea disabled-input" id="redText" :value="redText" disabled></textarea>
          </div>
          <div class="uk-width-auto">
            <button @click="deleteColor('red')"><span class="material-icons">close</span></button>
          </div>
        </div>

        <div class="blue" v-if="!blueVisible || (!blueVisible && !blackVisible && !greenVisible)">
          <button class="uk-button uk-button-border uk-button-small-padding" @click="blueVisible = true"><span class="material-icons">+</span></button>
        </div>
        <div v-if="blueVisible" class="blue uk-grid uk-grid-small uk-flex-middle uk-margin">
          <div class="uk-width-auto">
            <button class="blue uk-button uk-button-border uk-button-small-padding" @click="choosecolor('blue')" :class="activeClass('blue')">
              <md-icon style="color: blue;">mode_edit</md-icon>
            </button>
          </div>
          <div class="uk-width-expand">
            <textarea v-if="colors.includes('blue')" @input="getText('blue')" ref="blueText" class="uk-textarea blueText" id="blueText" :value="blueText"></textarea>
            <textarea v-else ref="blueText" class="uk-textarea disabled-input" id="blueText" :value="blueText" disabled></textarea>
          </div>
          <div class="uk-width-auto">
            <button @click="deleteColor('blue')"><span class="material-icons">close</span></button>
          </div>
        </div>

        <div class="green" v-if="!greenVisible && blueVisible">
          <button class="uk-button uk-button-border uk-button-small-padding" @click="greenVisible = true"><span class="material-icons">+</span></button>
        </div>
        <div v-if="greenVisible" class="green uk-grid uk-grid-small uk-flex-middle uk-margin">
          <div class="uk-width-auto">
            <button class="uk-button uk-button-border uk-button-small-padding" @click="choosecolor('green')" :class="activeClass('green')">
              <md-icon style="color: green;">mode_edit</md-icon>
            </button>
          </div>
          <div class="uk-width-expand">
            <textarea v-if="colors.includes('green')" @input="getText('green')" ref="greenText" class="uk-textarea greenText" id="greenText" :value="greenText"></textarea>
            <textarea v-else ref="greenText" class="uk-textarea disabled-input" id="greenText" :value="greenText" disabled></textarea>
          </div>
          <div class="uk-width-auto">
            <button @click="deleteColor('green')"><span class="material-icons">close</span></button>
          </div>
        </div>

        <div class="black" v-if="greenVisible && !blackVisible">
          <button class="uk-button uk-button-border uk-button-small-padding" @click="blackVisible = true"><span class="material-icons">+</span></button>
        </div>
        <div v-if="blackVisible" class="black uk-grid uk-grid-small uk-flex-middle uk-margin">
          <div class="uk-width-auto">
            <button class="uk-button uk-button-border uk-button-small-padding" @click="choosecolor('black')" :class="activeClass('black')">
              <md-icon style="color: black;">mode_edit</md-icon>
            </button>
          </div>
          <div class="uk-width-expand">
            <textarea v-if="colors.includes('black')" @input="getText('black')" ref="blackText" class="uk-textarea blackText" id="blackText" :value="blackText"></textarea>
            <textarea v-else ref="blackText" class="uk-textarea disabled-input" id="blackText" :value="blackText" disabled></textarea>
          </div>
          <div class="uk-width-auto">
            <button @click="deleteColor('black')"><span class="material-icons">close</span></button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "comment-photo",
  props: {
    srcImage: {
      type: String,
      require: true,
    },
    width: {
      type: Number,
      require: false,
      default: 560,
    },
    height: {
      type: Number,
      require: false,
      default: 360,
    },
    fixedPhoto: {
      type: Object,
      require: false,
    }

  },
  data() {
    return {
      canvas: null,
      backgroundcanvas: null,
      startX: 0,
      startY: 0,
      isDrawing: false,
      isErasing: false,
      imageWidth: 0,
      imageHeight: 0,
      points: [],
      trash: [],
      trashColors: [],
      history: [],
      color: 'orange',
      colors: [],
      stroke: [],
      blueText: null,
      greenText: null,
      redText: null,
      orangeText: null,
      blackText: null,
      trashblueText: null,
      trashgreenText: null,
      trashredText: null,
      trashorangeText: null,
      trashblackText: null,
      blackVisible: false,
      orangeVisible: true,
      blueVisible: true,
      redVisible: true,
      greenVisible: false,
      backgroundImage: null,
      image: null,
      comments: null,
      cursor: 'pencil',
      local_page_keys: {},
      correction: 1,
      lineWidth: 3,
      lineJoin: 'round',
      shadowColor: '#ffffff'
    }
  },
  methods: {
    action(e) {
      if (this.cursor == 'eraser') {
        this.color = '';
        this.erased(e);
      } else {
        this.draw(e);
      }
    },
    beginAction(e) {
      if (this.cursor == 'eraser') {
        this.color = '';
        this.beginErase(e);
      } else {
        this.beginDrawing(e);
      }
    },
    stopAction(e) {
      if (this.cursor == 'eraser') {
        this.stopErasing(e);
      } else {
        this.stopDrawing(e);
      }
    },
    getText(color) {
      if (color === 'blue') {
        this.blueText = this.$refs.blueText.value.trim();
      } else if (color === 'red') {
        this.redText = this.$refs.redText.value.trim();
      } else if (color === 'green') {
        this.greenText = this.$refs.greenText.value.trim();
      } else if (color === 'black') {
        this.blackText = this.$refs.blackText.value.trim();
      } else if (color === 'orange') {
        this.orangeText = this.$refs.orangeText.value.trim();
      }
    },
    emptyMessage() {
      alert(this.local_page_keys.alert_you_did_not_make_any_edits)
    },
    choosecolor(color) {
      this.cursor = 'pencil';
      this.color = color;
    },
    deleteColor(color) {
      if (color === 'blue') {
        this.blueText = null;
        this.blueVisible = false;
      } else if (color === 'red') {
        this.redText = null;
        this.redVisible = false;
      } else if (color === 'green') {
        this.greenText = null;
        this.greenVisible = false;
      } else if (color === 'black') {
        this.blackText = null;
        this.blackVisible = false;
      } else if (color === 'orange') {
        this.orangeText = null;
        this.orangeVisible = false;
      }
    },
    drawLine(x1, y1, x2, y2) {
      let ctx = this.canvas;
      ctx.beginPath();
      ctx.strokeStyle = this.color;
      ctx.lineWidth = this.lineWidth;
      ctx.lineJoin = this.lineJoin;
      ctx.shadowOffsetX = 1;
      ctx.shadowOffsetY = 1;
      ctx.shadowBlur    = 5;
      ctx.shadowColor   = this.color;//this.shadowColor;
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.closePath;
    },
    draw(e) {
      if (this.isDrawing && this.color !== '') {
        this.drawLine(this.startX * this.correction, this.startY * this.correction, e.offsetX * this.correction, e.offsetY * this.correction);
        this.startX = e.offsetX;
        this.startY = e.offsetY;
        this.points.push({
          x: e.offsetX * this.correction,
          y: e.offsetY * this.correction,
        });
      }
    },
    beginErase(e) {
      this.isErasing = true;
    },
    eraseLine(x, y) {
      let radius = 8;
      let diameter = radius*2;
      let frontimgdata = this.canvas.getImageData(x- radius, y-radius, diameter, diameter);
      let backimgdata = this.backgroundcanvas.getImageData(x-radius, y-radius, diameter, diameter);
      let count = diameter*diameter*4;
      let i = 0;
      let m, n, bc, ab;
      while(i <= count) {
        m = i/4;
        if (m < diameter) {
          n = 0;
        } else {
          n = 0;
          while (m >= diameter) {
            m -= diameter;
            n++;
          }
        }
        bc = radius - m;
        if (bc < 0) {
          bc = -bc;
        }
        ab = radius - n;
        if (ab < 0) {
          ab = -ab;
        }

        if (Math.sqrt(bc * bc + ab * ab) < radius) {
          frontimgdata['data'][i] = backimgdata['data'][i];
          frontimgdata['data'][i + 1] = backimgdata['data'][i + 1];
          frontimgdata['data'][i + 2] = backimgdata['data'][i + 2];
          frontimgdata['data'][i + 3] = backimgdata['data'][i + 3];
        }
        i += 4;
      }
      this.canvas.putImageData(frontimgdata, x - radius, y - radius);
    },
    erased(e) {
      if (this.isErasing) {
        //this.eraseLine(this.startX, this.startY);
        this.eraseLine(this.startX*this.correction, this.startY*this.correction, e.offsetX*this.correction, e.offsetY*this.correction);
        this.startX = e.offsetX;
        this.startY = e.offsetY;
        this.points.push({
          x: e.offsetX*this.correction,
          y: e.offsetY*this.correction,
        });
       }
    },
    stopErasing(e) {
      this.isErasing = false;
      if (this.points.length !== 0) {
        this.stroke['erased'] = [this.points];
        this.history.push(this.stroke);
        this.colors.push('erased');
        this.points = [];
        this.points.length = 0;
        this.stroke = [];
        this.stroke.length = 0;
      }
    },
    beginDrawing(e) {
      if (this.color !== '') {
        this.startX = e.offsetX;
        this.startY = e.offsetY;
        this.isDrawing = true;
      }
    },
    stopDrawing(e) {
      if (this.isDrawing) {
        this.drawLine(this.startX, this.startY, e.offsetX, e.offsetY);
        this.startX = 0;
        this.startY = 0;
        this.isDrawing = false;
        if (this.points.length > 0) {
          this.stroke[this.color] = [this.points];
          this.history.push(this.stroke);
          this.colors.push(this.color);
          this.points = [];
          this.points.length = 0;
          this.stroke = [];
          this.stroke.length = 0;
        }
      }
    },
    resetCanvas() {
      this.$emit('reset', null)
      const {width, height} = this.init();
      this.canvas.clearRect(0, 0, width, height);
      this.canvas.drawImage(this.backgroundImage, 0, 0, width, height);
      this.history.length = 0;
      this.points.length = 0;
      this.trash.length = 0;
      this.blueText = null;
      this.redText = null;
      this.greenText = null;
      this.blackText = null;
      this.orangeText = null;
      this.trashblueText = null;
      this.trashgreenText = null;
      this.trashblackText = null;
      this.trashredText = null;
      this.trashorangeText = null;
      this.colors.length = 0;
      this.trashColors.length = 0;
      this.blackVisible = false;
      this.orangeVisible = true;
      this.blueVisible = true;
      this.redVisible = true;
      this.greenVisible = false;
      this.cursor = '';

    },
    undo() {
      let strokes = this.history.pop();
      let trash_colors = this.colors.pop();
      this.trashblueText = (trash_colors === 'blue' ? this.blueText : this.trashblueText);
      this.trashgreenText = (trash_colors === 'green' ? this.greenText : this.trashgreenText);
      this.trashblackText = (trash_colors === 'black' ? this.blackText : this.trashblackText);
      this.trashredText = (trash_colors === 'red' ? this.redText : this.trashredText);
      this.trashorangeText = (trash_colors === 'orange' ? this.orangeText : this.trashorangeText);
      this.blueText = (trash_colors === 'blue' ? null : this.blueText);
      this.greenText = (trash_colors === 'green' ? null : this.greenText);
      this.redText = (trash_colors === 'red' ? null : this.redText);
      this.blackText = (trash_colors === 'black' ? null : this.blackText);
      this.orangeText = (trash_colors === 'orange' ? null : this.orangeText);
      if (strokes && trash_colors) {
        this.redraw(this.history);
        this.trash.push(strokes);
        this.trashColors.push(trash_colors);
      }
    },
    saveImage() {
      let canSend = this.canSend();
      if (canSend) {
        if (confirm(this.local_page_keys.alert_are_you_sure_you_have_made_all_the_necessary_edits)) {

          const myCanvas = document.querySelector('#myCanvas');
          const dataURI = myCanvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
          let convertImg = new Image();
          convertImg.src = dataURI;
          this.image = dataURI;
          let blue_note = (this.blueText !== null ? this.blueText : '');
          let red_note = (this.redText !== null ? this.redText : '');
          let green_note = (this.greenText !== null ? this.greenText : '');
          let black_note = (this.blackText !== null ? this.blackText : '');
          let orange_note = (this.orangeText !== null ? this.orangeText : '');
          this.comments = JSON.stringify({blue_note, red_note, green_note, black_note, orange_note});
          this.$emit('image', this.image);
          this.$emit('fields', this.comments);
          this.$emit('classDisplay', 'display');
          this.$emit('close');
        }
     } else {
        alert(this.local_page_keys.alert_you_did_not_fill_out_the_comments)
     }
    },
    redo() {
      if (this.trash.length > 0) {
        let undoColors = this.trashColors.pop();
        this.blueText = (undoColors === 'blue' ? this.trashblueText : this.blueText);
        this.greenText = (undoColors === 'green' ? this.trashgreenText : this.greenText);
        this.blackText = (undoColors === 'black' ? this.trashblackText : this.blackText);
        this.redText = (undoColors === 'red' ? this.trashredText : this.redText);
        this.orangeText = (undoColors === 'orange' ? this.trashorangeText : this.orangeText);
        let undoStroke = this.trash.pop();
        this.colors.push(undoColors)
        this.history.push(undoStroke);
        this.redraw(this.history);
      }
    },
    canSend() {
      if (this.colors.includes('blue') && (this.blueText === null || this.blueText ==='')) {
        return false;
      } else if (this.colors.includes('red') && (this.redText == null || this.redText ==='')) {
        return false;
      } else if (this.colors.includes('green') && (this.greenText == null || this.greenText ==='')) {
        return false;
      } else if (this.colors.includes('black') && (this.blackText == null || this.blackText ==='')) {
        return false;
      } else if (this.colors.includes('orange') && (this.orangeText == null || this.orangeText ==='')) {
        return false;
      } else {
        return true;
      }
    },
    redraw(history) {
      const {width, height} = this.init();
      this.canvas.clearRect(0, 0, width, height);
      this.canvas.drawImage(this.backgroundImage, 0, 0, width, height);
      history.forEach((value) => {
        let strokes = Object.entries(value);
        strokes.forEach(stroke => {
          let currcolor = stroke[0];
          if (currcolor !== 'erased') {
            stroke[1].forEach(points => {
              let ctx = this.canvas;
              let began = points.at(0);
              ctx.beginPath();
              ctx.strokeStyle = currcolor;
              ctx.moveTo(began.x, began.y);
              points.forEach((point) => {
                ctx.lineTo(point.x, point.y);
              })
              ctx.stroke();
              ctx.closePath;
            })
          } else {
            stroke[1].forEach(points => {
              points.forEach((point) => {
                this.eraseLine(point.x, point.y);
              })
            })
          }
        })
      })
    },
    init() {
      const canvas = document.getElementById("myCanvas");
      const canvasWrapper = document.querySelector('.canvas-wrapper');
      const widthWrapper = parseInt(window.getComputedStyle(canvasWrapper).width);
      const heightWrapper = parseInt(window.getComputedStyle(canvasWrapper).height);

      if ((widthWrapper < this.width) && (this.width > this.height)) {
        this.imageWidth = widthWrapper;
        this.imageHeight = Math.ceil((widthWrapper * this.height) / this.width);
      } else if (this.height > this.width) {
        this.imageHeight = heightWrapper;
        this.imageWidth = Math.floor((heightWrapper * this.width) / this.height);
      } else {
        this.imageHeight = heightWrapper;
        this.imageWidth = Math.floor((heightWrapper * this.width) / this.height);
        //Компенсация искажения линии после изменения ширины
        this.correction = heightWrapper / widthWrapper;
      }

      return {
        width: this.imageWidth,
        height: this.imageHeight
      }
    },
    activeClass(color) {
      return (color === this.color ? 'activeColor' : '')
    },
    changeCursor() {
      return this.cursor;
    },
    eraser() {
      this.cursor = 'eraser';
    },
    initComments() {
      if (this.fixedPhoto.fields) {
        let fixedPhotoFields = JSON.parse(this.fixedPhoto.fields);
        for (const key in fixedPhotoFields) {
          if (key.endsWith("_note")) {
            const newKey = key.replace("_note", "");
            if (fixedPhotoFields[key]) {
             this[newKey + 'Text'] = fixedPhotoFields[key];
             this[newKey + 'Visible'] = true
             this.colors.push(newKey)
           }
          }
        }
      }
    }
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('order-comment-photo');
    const {width, height} = this.init();
    let c = document.getElementById("myCanvas");
    this.canvas = c.getContext('2d');
    let bc = document.getElementById("backgroundCanvas");
    this.backgroundcanvas = bc.getContext('2d');
    let bctx = this.backgroundcanvas;
    let ctx = this.canvas;
    let re = "raw=1";
    let image = new Image(width, height);
    if (this.srcImage.includes(re)) {
      image.crossOrigin = '*';
    }
    image.onload = drawImageActualSize;
    image.src = this.srcImage;
    this.backgroundImage = image;
    function drawImageActualSize() {
      ctx.drawImage(this, 0, 0, width, height);
      bctx.drawImage(this, 0, 0, width, height);
    }
    this.initComments();
  }
}
</script>

<style>
  #myCanvas {
    background-color: #d7d7d7;
    z-index: 1;
  }
  #backgroundCanvas {
    position: absolute;
    z-index: 0;
  }
  .pencil {
    cursor: url(/img/pencil-cursor.png) 0 0,crosshair;
  }
  .eraser {
    cursor: url(/img/eraser_new.png) 12 40,crosshair;
  }
  .blueText, .blue {
    color: blue;
  }
  .redText, .red {
    color: red;
  }
  .greenText, .green {
    color: green;
  }
  .blackText, .black {
    color: black;
  }
  .orangeText, .orange {
    color: orange;
  }
  .comment-photo-class {
    display: flex;
    flex-direction: row;
  }
  .canvas-section {
    display: flex;
    flex-direction: column;
  }
  .canvas-buttons .uk-button {
    border-radius: 0;
    border: #a9a9a9 2px solid;
  }
  .canvas-buttons .uk-button:hover,
  .canvas-buttons .uk-button:focus {
    background-color: #eee;
  }
  .canvas-buttons .reset-button {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    background: #a9a9a9;
    color: #fff;
  }
  .canvas-buttons .save-button {
    background: #4caf50;
    border: #4caf50 2px solid;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    color: #fff;
  }
  .canvas-buttons .save-button.uk-button:hover,
  .canvas-buttons .save-button.uk-button:focus {
    background-color: #3d9340;
    border-color: #3d9340;
  }
  .canvas-buttons .save-button-disebled {
    background: #a9a9a9;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    color: #fff;
  }
  .canvas-buttons .reset-button.uk-button:hover,
  .canvas-buttons .reset-button.uk-button:focus,
  .canvas-buttons .save-button-disebled.uk-button:hover,
  .canvas-buttons .save-button-disebled.uk-button:focus {
    background-color: #888;
    border-color: #888;
  }
  .eraser {
    background-color: #eee;
  }
  .canvas-buttons .eraser.uk-button {
    background-color: rgb(61 147 64 / 50%);
  }
  .disabled-input {
    /*width: 85%;*/
    border: grey 1px solid;
    padding: 2px;
  }

  .activeColor {
    background-color: #efefef !important;
    border: 1px solid #b2b2b2 !important;
  }
</style>